module.exports = __webpack_public_path__ + "img/email.8f4240f5.png";